export default __webpack_public_path__ + "static/accelerate_hire_ios-57dd22e1e1e6e497db5487b314d76ec9.webp";